import { API_HOST, DOCUMENT_API_HOST, getHttpGetOptions, getHttpPostOptions } from '../../utils/api-util';

const getEndpoint = () => `${DOCUMENT_API_HOST}`;
const getSpecificEndpoint = (documentExternalReference) => `${getEndpoint()}/${documentExternalReference}`;

export const getDownloadDocumentRequest = (documentExternalReference, responseType) => [
  getSpecificEndpoint(documentExternalReference),
  getHttpGetOptions({ documentExternalReference }, null, responseType)
];

export const getUploadDocumentRequest = (document, headers) => [getEndpoint(), getHttpPostOptions(document, headers)];

const getUploadChunkEndpoint = () => `${API_HOST}/videos/chunk`;
export const getUploadChunkRequest = (chunk, headers, params) => [
  getUploadChunkEndpoint(),
  getHttpPostOptions(chunk, headers, params)
];

const getCancelVideoUploadEndpoint = () => `${API_HOST}/videos/uploads/cancel`;
export const getCancelVideoUploadRequest = (params) => [
  getCancelVideoUploadEndpoint(),
  getHttpPostOptions(null, null, params)
];
